const getters = {
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  token: state => state.user.token,
  name: state => state.user.name,
  roles: state => state.user.roles,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js